exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".rw-multiselect-taglist li {\n\tbackground-color: white;\n}\n.rw-multiselect-taglist li>span {\n\t    padding: 0px 5px;\n}\n\n.users__management-status {\n\ttext-align: center;\n}\n\n.users__management-roles {\n\tdisplay: flex;\n\tflex-wrap: wrap;\n\twhite-space: pre-wrap;\n}\n", ""]);

// exports
